import $ from 'jquery';
import 'slick-carousel/slick/slick';
import 'select2';

import './js/hexagon-hero';
import './js/hexagon-mini';
import './js/collapse';
import './js/vselect';
import './js/line-chart';
import './js/spider-chart';
import './js/country-profile';
import './js/data-archive';

import "./js/jvectormap/jquery-jvectormap.min.js";
import "./js/map/jquery-jvectormap-world-mill"; // Map file
import './js/interactive-map';
import './js/social-share';

jQuery(function(){
  console.log('Ready');

  const baseUrl = $('#base-url').data('base-url');

  $('.menu .menu-item a:contains("GSoD Indices")').on('click', function(e) {
    e.preventDefault();

    const url = $(this).attr('href');

    window.open(url, '_blank');
  });

  if ($('#world-map-countries').length > 0) {
    $('#world-map-countries').select2();

    $('#world-map-countries').on('change', function(){
      const permalink = $(this).val();

      const parseLink = permalink.substring(permalink.indexOf('/country'), permalink.length);

      window.open('https://idea.int/democracytracker'+parseLink, '_blank');
    });
  }

  $('#button-menu-toggle').on('click', function(){
    if ($('#mobile-menu').hasClass('active')) {
      $(this).removeClass('active');
      $('#mobile-menu').removeClass('active');
      $('#mobile-menu').fadeOut();
      $('body').removeClass('overflow-hidden');
    } else {
      $(this).addClass('active');
      $('#mobile-menu').addClass('active');
      $('#mobile-menu').fadeIn();
      $('body').addClass('overflow-hidden');
    }
  });

  // Add a class to style 'Country profiles' menu item in main nav
  $('.nav-desktop .menu-item a:contains("Country profiles")').addClass('menu-has-dropdown');
  $('.nav-mobile .menu-item a:contains("Country profiles"), .nav-desktop .menu-item a:contains("Country profiles")').on('click', function(e){
    e.preventDefault();
  });

  let cancel = false;

  // Hover to open Countries dropdown menu
  $('.nav-desktop .menu-item a:contains("Country profiles")').on('mouseenter', function(e) {
    e.preventDefault();

    cancel = true;
    $('#dropdown-menu-countries').fadeIn();
    $('.nav-desktop .menu-item.menu-item--expanded ul.menu').fadeOut();
  });

  $('.nav-desktop .menu-item a:not(:contains("Country profiles"))').on('mouseenter', function(e) {
    $('#dropdown-menu-countries').fadeOut();
    // console.log('hello');
  });

  $('.nav-desktop .menu-item a:contains("Country profiles")').on('mouseleave', function(e) {
    e.preventDefault();

    cancel = false;
  });

  
  $('#dropdown-menu-countries').on('mouseleave', function(e){
    // console.log('mouseleave');
    // e.stopPropagation();
    //  return false;
    setTimeout(() => {
      if (!cancel) {
        $('#dropdown-menu-countries').fadeOut();
      }
    }, 250);
  });
  
  $('.nav-desktop .menu-item.menu-item--expanded').on('mouseenter', function(e) {
    $(this).find('ul.menu').fadeIn();
    $('#dropdown-menu-countries').fadeOut();
  });

  $('.nav-mobile .menu-item.menu-item--expanded a, .nav-desktop .menu-item.menu-item--expanded a').on('click', function(e){
    if ($(this).parent().hasClass('menu-item--expanded')) {
      e.preventDefault();
    }
  });

  $('.nav-desktop .menu-item.menu-item--expanded').on('mouseleave', function(){
    $(this).find('ul.menu').fadeOut();
  });

  // Hide menu when click outside of menu
  $(document).on('mouseup', function(e) {
    var container = $('#dropdown-menu-countries');

    if (!container.is(e.target) && container.has(e.target).length === 0) {
      container.fadeOut();
    }
  });

  // Tooltip for attributes
  $('.attribute-tooltip-hover').on('mouseenter', function() {
    const tooltip = $(this).data('tooltip');
    const tt = $(this).find('img');
    
    $('body').append('<div class="attribute-tooltip"><div class="tooltip-content">' + tooltip + '</div></div>');

    $('.attribute-tooltip').css('top', tt.offset().top);
    $('.attribute-tooltip').css('left', tt.offset().left + (tt.width() / 2));
  });

  $('.attribute-tooltip-hover').on('mouseleave', function() {
    $('.attribute-tooltip').remove();
  });

  // Tab control for drop-down countries menu (desktop)
  $('#dropdown-menu-countries .region-tab-toggle').on('click', function(){
    const idx = $(this).data('index');

    $('#dropdown-menu-countries .region-tab-toggle.active').removeClass('active');
    $(this).addClass('active');

    $('#dropdown-menu-countries .countries-menu-group.active').removeClass('active');
    $('#dropdown-menu-countries .countries-menu-group.group-'+idx).addClass('active');

  });

  // Move continent menu and countries list into mobile menu element
  $('#mobile-menu .menu .menu-item:nth-child(2)').first().append($('#continent-menu-mobile'));
  $('#mobile-menu').append($('.mobile-menu-countries-list'));

  // On continent clicked, open countries list
  $('.continent-menu-each-click').on('click', function(){
    const target = $($(this).data('target'));

    target.addClass('active');

    setTimeout(() => {
      target.addClass('show');
    }, 50);
  });

  // Close countries list and back to mobile menu
  $('.back-to-menu-click').on('click', function(){
    $('.mobile-menu-countries-list').removeClass('show');

    setTimeout(() => {
      $('.mobile-menu-countries-list').removeClass('active');
    }, 300);
  });

  // Country profile, expand body text when clicked on "Read more"
  if ($('#country-body').length > 0) {
    const cbElm = $('#country-body');
    const shortContent = cbElm.find('.country-body-content').html();
    const fullContent = $('#country-full-body').html();
    let och = cbElm.find('.country-body-content').height(); // Original content height
    cbElm.height(och);

    $('#country-full-body').remove();

    $('#country-body-read-more').on('click', function(e){
      e.preventDefault();

      och = cbElm.find('.country-body-content').height();

      cbElm.find('.country-body-content').html(fullContent);
      
      const nh = cbElm.find('.country-body-content').height();
      cbElm.height(nh);

      setTimeout(() => {
        cbElm.height('auto');
      }, 600);

      $(this).hide();
      $('#country-body-read-less').show();
    });
    
    $('#country-body-read-less').on('click', function(e){
      e.preventDefault();

      const ch = cbElm.find('.country-body-content').height(); // Current height
      cbElm.height(ch);
      
      setTimeout(() => {
        cbElm.height(och);
      }, 50);
      
      setTimeout(() => {
        cbElm.find('.country-body-content').html(shortContent);
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#country-body").offset().top
        }, 1500);
      }, 100);

      $(this).hide();
      $('#country-body-read-more').show();
    });
  }

  // Slick sliders
  if ($('.gsod-post-slider').length > 0) {
    $('.gsod-post-slider').each(function () {
      const elm = $(this);
      const nav = $(elm.data('nav'));

      elm.slick({
        infinite: false,
        appendArrows: nav,
      })
    });
  }

  if ($('.gsod-page-slider').length > 0) {
    $('.gsod-page-slider').each(function () {
      const elm = $(this);
      const nav = $(elm.data('nav'));

      elm.slick({
        infinite: false,
        appendArrows: nav,
        // adaptiveHeight: true,
      })

      $(elm.data('nav') + " button:first-child").after('<span class="font-aileron font-bold text-xs uppercase">1 of ' + elm.slick('getSlick').slideCount + '</span>');

      elm.on('afterChange', function(datak, data) {
        nav.find('span').text((data.currentSlide + 1) + ' of ' + data.slideCount);
      });
    });
  }

  if ($('.even-card-report-description').length > 0) {
    $('.even-card-report-description a').on('click', function(e) {
      e.preventDefault();

      const url = $(this).attr('href');
      window.open(url, '_blank');
    });
  }

  $('.link-tag.data-archive').on('click', function(e){
    e.preventDefault();

    const id = $(this).data('id');

    window.location = baseUrl + 'data-archive?tag='+id;
  });

  // Smooth scrolling to anchor #
  $('a[href*=\\#]:not([href=\\#])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top
        }, 1000);
        return false;
      }
    }
  });

  $('#button-close-message-banner').on('click', function(){
    $(this).parent().remove();
  });

  $('.open-link-in-new-tab').on('click', 'a', function(e){
    console.log('new');
    const url = $(this).attr('href');

    if (url.indexOf('http') >= 0) {
      e.preventDefault();
      window.open(url, '_blank');
    }
  });

});
// Document.ready END
///////////////////////////////////////////////////////////////////////////////
